export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      programs: "Programmes",
      diploma: "Diplôme américain",
      admissions: "Admissions",
      contact: "Contact",
      inquiry: "Demande d'informations",
      login: "Connexion",
      register: "Créer un compte",
      signup: "S'inscrire",
      logout: "Déconnexion",
      dashboard: "Tableau de bord",
    },
    common: {
      submit: "Envoyer",
      save: "Enregistrer",
      cancel: "Annuler",
      next: "Suivant",
      back: "Retour",
      continue: "Continuer",
      loading: "Chargement…",
      yes: "Oui",
      no: "Non",
      email: "Email",
      password: "Mot de passe",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Téléphone / WhatsApp",
      country: "Pays de résidence",
      language: "Langue préférée",
      fr: "Français",
      en: "Anglais",
      search: "Rechercher",
      status: "Statut",
      actions: "Actions",
      view: "Voir",
      edit: "Modifier",
      delete: "Supprimer",
      export: "Exporter CSV",
      filters: "Filtres",
      all: "Tous",
      welcome: "Bienvenue",
      optional: "(optionnel)",
      required: "obligatoire",
    },
    landing: {
      overline: "Premier lycée franco-américain en ligne",
      heroTitle: "Un avenir international, sans quitter la France.",
      heroSubtitle:
        "OFA France propose un parcours académique américain structuré, en parallèle du système français — de la Grande Section à la Terminale, avec la possibilité d'obtenir un US High School Diploma accrédité COGNIA.",
      heroBadge: "Diplôme américain accrédité · 4 à 8 élèves par classe · 32 semaines",
      heroPlatformKicker: "Plateforme d'inscription & de vie scolaire",
      heroPlatformIntro: "OFA Portail Familles",
      heroPlatformSub: "De la demande d'informations à l'inscription.",
      heroLead: "Un parcours américain en France, de la grande section à la terminale.",
      heroDiscoverHint: "Pour découvrir nos programmes en détail, rendez-vous sur ofalycee.fr.",
      ctaInquiry: "Demande d'informations",
      ctaApply: "S'inscrire",
      ctaPrograms: "Découvrir les programmes",
      programs: "Nos parcours",
      programsSubtitle: "Souplesse, rigueur, accompagnement.",
      whyTitle: "Une école, deux parcours complémentaires",
      whySubtitle:
        "Tous les élèves d'OFA France préparent et obtiennent le Baccalauréat français dans leur lycée. En parallèle, ils suivent avec OFA France un parcours américain bilingue, pouvant mener au High School Diploma américain, accrédité par Cognia.",
      ctaHelper: "« S'inscrire » ouvre votre espace famille pour commencer la candidature. « Demande d'informations » est libre, sans création de compte.",
      footerNote: "OFA France · Branche française d'OFALycée · Accrédité COGNIA",
      journeyOverline: "Un seul espace, de A à Z",
      journeyTitle: "Les étapes pour inscrire votre enfant.",
      journeySubtitle: "Trois étapes pour rejoindre OFA France : du dossier d'admission à la confirmation d'inscription.",
      journeyStep1: "Demande d'admission",
      journeyStep1Sub: "Remplir le formulaire en ligne",
      journeyStep2: "Étude du dossier",
      journeyStep2Sub: "+ Évaluation du niveau d'anglais",
      journeyStep3: "Entretien",
      journeyStep3Sub: "Échange avec l'équipe pédagogique",
      journeyStep4: "Paiement & inscription",
      journeyStep4Sub: "Validation finale de votre inscription",
      heroPrefix: "Le",
      heroFirst: "1ᵉʳ",
      heroMain: "lycée franco-américain en ligne.",
    },
    programs: {
      fluent_track: "Maintenir son niveau d'anglais (niveau avancé à natif)",
      bridge_track: "Devenir bilingue (Bridge Track)",
      diploma: "US High School Diploma",
      other: "Autre",
    },
    tracks: {
      fluent: "Fluent Track",
      bridge: "Bridge Track",
      undecided: "À déterminer",
    },
    inquiry: {
      title: "Demande d'information",
      subtitle:
        "Quelques minutes suffisent. Notre équipe revient vers vous sous 48 heures.",
      parentSection: "Parent",
      childSection: "Enfant",
      programSection: "Programme",
      childFirstName: "Prénom de l'enfant",
      childLastName: "Nom de l'enfant",
      dateOfBirth: "Date de naissance",
      currentGrade: "Classe actuelle",
      currentSchoolSystem: "Système scolaire actuel",
      nationality: "Nationalité",
      city: "Ville",
      postalCode: "Code postal",
      frenchLevel: "Niveau de français",
      englishLevel: "Niveau d'anglais",
      programInterest: "Programme qui vous intéresse",
      mainGoal: "Objectif principal",
      track: "Voie souhaitée",
      message: "Message / situation particulière",
      success: "Merci ! Votre demande a bien été enregistrée.",
      submit: "Envoyer ma demande",
    },
    levels: {
      native: "Natif",
      advanced: "Avancé",
      intermediate: "Intermédiaire",
      beginner: "Débutant",
      none: "Aucun",
    },
    auth: {
      loginTitle: "Connexion",
      registerTitle: "Créer un compte parent",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      registerHere: "Inscrivez-vous",
      loginHere: "Connectez-vous",
      loginCta: "Se connecter",
      registerCta: "Créer mon compte",
      googleLogin: "Continuer avec Google",
      googleSoon: "Connexion Google bientôt disponible",
      forgotPassword: "Mot de passe oublié ?",
      loginIntro: "Bon retour ! Connectez-vous à votre espace OFA France pour suivre la candidature de votre enfant.",
      noEnrollmentYet: "Aucun élève inscrit pour l'instant — finissez d'abord l'inscription pour accéder à la Vie scolaire.",
    },
    parent: {
      welcome: "Bienvenue à OFA France",
      journeyTitle: "Votre parcours d'inscription",
      myApplication: "Ma candidature",
      myDocuments: "Mes documents",
      myEnrollment: "Mon inscription",
      myPayment: "Paiement",
      mySchedule: "Emploi du temps",
      myProfile: "Mon profil",
      startApplication: "Commencer la candidature",
      continueApplication: "Reprendre la candidature",
      submitApplication: "Soumettre la candidature",
      acceptOffer: "Accepter l'offre",
      signAgreement: "Signer l'accord d'inscription",
      choosePayment: "Choisir le mode de paiement",
      chooseSchedule: "Choisir l'emploi du temps",
      noApplications: "Aucune candidature pour le moment.",
      stepInquiry: "Demande",
      stepStarted: "Candidature commencée",
      stepSubmitted: "Candidature envoyée",
      stepReview: "En cours d'examen",
      stepAccepted: "Acceptée",
      stepEnrolled: "Inscrit",
      stepScheduled: "Planifié",
      stepActive: "Actif",
    },
    admin: {
      dashboard: "Tableau de bord",
      inquiries: "Demandes d'infos",
      applications: "Candidatures",
      admissions: "Admissions",
      enrollments: "Inscriptions",
      reenrollment: "Réinscriptions",
      pendingPayments: "Simulateur paiement",
      payments: "Paiements",
      sepa: "Prélèvements SEPA",
      scheduling: "Emploi du temps",
      grouping: "Aide au regroupement",
      myCourses: "Mes cours",
      section_admissions: "Admissions",
      section_studentLife: "Vie scolaire",
      section_system: "Système",
      calendar: "Calendrier scolaire",
      families: "Familles",
      students: "Élèves",
      sis: "SIS · Vie scolaire",
      emails: "Emails",
      analytics: "Analytique",
      auditLogs: "Sécurité · Audit",
      staff: "Équipe · Comptes",
      settings: "Paramètres",
      totalInquiries: "Demandes totales",
      applicationsStarted: "Candidatures débutées",
      applicationsSubmitted: "Candidatures envoyées",
      acceptedStudents: "Élèves acceptés",
      enrolledStudents: "Élèves inscrits",
      conversionRate: "Taux de conversion",
      revenuePipeline: "Revenu prévu",
      pendingPayments: "Paiements en attente",
      byGrade: "Par niveau",
      byProgram: "Par programme",
      byCountry: "Par pays",
      convertToApplication: "Convertir en candidature",
      sendEmail: "Envoyer un email",
      changeStatus: "Changer le statut",
      noteAdded: "Note ajoutée",
      addNote: "Ajouter une note",
      tags: "Étiquettes",
    },
    statuses: {
      new: "Nouveau",
      contacted: "Contacté",
      converted: "Converti",
      archived: "Archivé",
      started: "Commencée",
      fee_pending: "Frais à régler",
      submitted: "Envoyée",
      under_review: "En examen",
      evaluation_sent: "Évaluation envoyée",
      evaluation_received: "Évaluation reçue",
      accepted: "Acceptée",
      rejected: "Refusée",
      withdrawn: "Retirée",
      enrolled: "Inscrit",
      active: "Actif",
      pending: "En attente",
      deposit_paid: "Acompte payé",
      paid_in_full: "Payé intégralement",
      plan_active: "Plan actif",
      overdue: "En retard",
      simulated: "Simulé",
    },
    payments: {
      annual: "Paiement en 1 fois (annuel)",
      biannual: "Paiement en 2 fois",
      monthly: "Paiement en 10 fois (mensuel)",
      custom: "Plan personnalisé",
    },
    appSteps: {
      family: "Famille",
      student: "Élève",
      academic: "Parcours scolaire",
      language: "Profil linguistique",
      program: "Programme",
      documents: "Documents",
      consent: "Engagement",
      docsTitle: "Bulletins scolaires demandés",
      docsHelp: "Merci de téléverser les bulletins des 2 dernières années : l'année en cours et l'année précédente (PDF ou image, 2,5 Mo max par fichier).",
      docsCta: "Cliquer pour téléverser un bulletin",
    },
    legal: {
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      copyright: "© {year} OFA France — Tous droits réservés",
    },
    contract: {
      title: "Contrat d'inscription — Année académique",
      preamble: "Le présent contrat lie OFA France (« l'École ») et la famille soussignée (« la Famille ») pour la scolarisation de l'élève désigné sur la plateforme.",
      art1Title: "Article 1 — Objet",
      art1: "OFA France propose un parcours académique américain en ligne, en parallèle du système scolaire français, comprenant les cours d'anglais académique et, au niveau lycée, les cours d'American History pour les familles qui visent le US High School Diploma accrédité COGNIA.",
      art2Title: "Article 2 — Engagement de l'École",
      art2: "L'École s'engage à délivrer les cours selon le programme retenu (Fluent Track ou Bridge Track), à raison de 1h30 par semaine sur 32 semaines de cours, dans des classes de 4 à 8 élèves, avec des professeurs anglophones expérimentés.",
      art3Title: "Article 3 — Engagement de la Famille",
      art3: "La Famille s'engage à assurer l'assiduité de l'élève, à fournir les documents demandés (bulletins des 2 dernières années, pièce d'identité) et à régler les frais de scolarité selon le plan de paiement choisi.",
      art4Title: "Article 4 — Frais de scolarité",
      art4: "Les frais annuels sont de 1 995 € par cours, pour tous les niveaux de la GS à la Terminale (soit 3 990 € pour deux cours). Trois plans de paiement sont proposés : en 1 fois (annuel), en 2 fois (semestriel) ou en 10 fois (mensuel d'octobre à juillet).",
      art5Title: "Article 5 — Annulation et remboursement",
      art5: "Toute annulation après le démarrage des cours fera l'objet d'un examen au cas par cas. Le premier trimestre n'est pas remboursable. La Famille peut résilier à tout moment moyennant un préavis de 30 jours.",
      art6Title: "Article 6 — Données personnelles",
      art6: "OFA France traite les données personnelles conformément au RGPD. Voir notre Politique de confidentialité pour les détails.",
      art7Title: "Article 7 — Droit applicable",
      art7: "Le présent contrat est soumis au droit français. Tout litige relèvera de la compétence des tribunaux de Paris.",
      signature: "En cochant la case ci-dessous, je signe électroniquement ce contrat et confirme l'inscription.",
      readFull: "Lire le contrat complet",
      hideFull: "Masquer le contrat",
    },
  },
  en: {
    nav: {
      home: "Home",
      programs: "Programs",
      diploma: "US Diploma",
      admissions: "Admissions",
      contact: "Contact",
      inquiry: "Request information",
      login: "Sign in",
      register: "Create account",
      signup: "Apply",
      logout: "Sign out",
      dashboard: "Dashboard",
    },
    common: {
      submit: "Submit",
      save: "Save",
      cancel: "Cancel",
      next: "Next",
      back: "Back",
      continue: "Continue",
      loading: "Loading…",
      yes: "Yes",
      no: "No",
      email: "Email",
      password: "Password",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone / WhatsApp",
      country: "Country of residence",
      language: "Preferred language",
      fr: "French",
      en: "English",
      search: "Search",
      status: "Status",
      actions: "Actions",
      view: "View",
      edit: "Edit",
      delete: "Delete",
      export: "Export CSV",
      filters: "Filters",
      all: "All",
      welcome: "Welcome",
      optional: "(optional)",
      required: "required",
    },
    landing: {
      overline: "First French-American online lycée",
      heroTitle: "An international future, without leaving France.",
      heroSubtitle:
        "OFA France offers a structured American academic pathway alongside the French system — from Kindergarten to 12th grade, with the option to earn a COGNIA-accredited US High School Diploma.",
      heroBadge: "COGNIA-accredited diploma · 4–8 students per class · 32 weeks",
      heroPlatformKicker: "Enrollment & school-life platform",
      heroPlatformIntro: "OFA Family Hub",
      heroPlatformSub: "From information request to enrollment.",
      heroLead: "An American pathway in France, from kindergarten through high school.",
      heroDiscoverHint: "To explore our programs in detail, visit ofalycee.fr.",
      ctaInquiry: "Request information",
      ctaApply: "Apply now",
      ctaPrograms: "Explore programs",
      programs: "Our programs",
      programsSubtitle: "Flexibility, rigor, support.",
      whyTitle: "One school, two complementary pathways",
      whySubtitle:
        "All OFA France students prepare and obtain their French Baccalauréat at their lycée. Alongside, they follow an American bilingual program with OFA France, leading optionally to a US High School Diploma accredited by Cognia.",
      ctaHelper: "“Apply” opens your family portal to start the application. “Request information” is open and requires no account.",
      footerNote: "OFA France · French branch of OFALycée · COGNIA accredited",
      journeyOverline: "One space, end to end",
      journeyTitle: "Steps to enroll your child.",
      journeySubtitle: "Three steps to join OFA France: from admission application to enrollment confirmation.",
      journeyStep1: "Admission application",
      journeyStep1Sub: "Fill out the online form",
      journeyStep2: "File review",
      journeyStep2Sub: "+ English level assessment",
      journeyStep3: "Interview",
      journeyStep3Sub: "Meeting with the academic team",
      journeyStep4: "Payment & enrollment",
      journeyStep4Sub: "Final validation of your enrollment",
      heroPrefix: "The",
      heroFirst: "1ˢᵗ",
      heroMain: "French-American online lycée.",
    },
    programs: {
      fluent_track: "Maintain your English level (advanced to native)",
      bridge_track: "Becoming bilingual (Bridge Track)",
      diploma: "US High School Diploma",
      other: "Other",
    },
    tracks: {
      fluent: "Fluent Track",
      bridge: "Bridge Track",
      undecided: "Undecided",
    },
    inquiry: {
      title: "Inquiry form",
      subtitle:
        "Just a few minutes. Our team will get back to you within 48 hours.",
      parentSection: "Parent",
      childSection: "Child",
      programSection: "Program",
      childFirstName: "Child's first name",
      childLastName: "Child's last name",
      dateOfBirth: "Date of birth",
      currentGrade: "Current grade",
      currentSchoolSystem: "Current school system",
      nationality: "Nationality",
      city: "City",
      postalCode: "Postal code",
      frenchLevel: "French level",
      englishLevel: "English level",
      programInterest: "Program of interest",
      mainGoal: "Main goal",
      track: "Preferred track",
      message: "Message / specific situation",
      success: "Thank you! Your inquiry has been received.",
      submit: "Send my inquiry",
    },
    levels: {
      native: "Native",
      advanced: "Advanced",
      intermediate: "Intermediate",
      beginner: "Beginner",
      none: "None",
    },
    auth: {
      loginTitle: "Sign in",
      registerTitle: "Create a parent account",
      noAccount: "No account yet?",
      hasAccount: "Already have an account?",
      registerHere: "Register",
      loginHere: "Sign in",
      loginCta: "Sign in",
      registerCta: "Create my account",
      googleLogin: "Continue with Google",
      googleSoon: "Google sign-in coming soon",
      forgotPassword: "Forgot password?",
      loginIntro: "Welcome back! Sign in to your OFA France space to track your child's application.",
      noEnrollmentYet: "No enrolled student yet — please complete enrollment first to access Student Life.",
    },
    parent: {
      welcome: "Welcome to OFA France",
      journeyTitle: "Your enrollment journey",
      myApplication: "My application",
      myDocuments: "My documents",
      myEnrollment: "My enrollment",
      myPayment: "Payment",
      mySchedule: "Schedule",
      myProfile: "My profile",
      startApplication: "Start application",
      continueApplication: "Continue application",
      submitApplication: "Submit application",
      acceptOffer: "Accept offer",
      signAgreement: "Sign enrollment agreement",
      choosePayment: "Choose payment plan",
      chooseSchedule: "Choose schedule",
      noApplications: "No applications yet.",
      stepInquiry: "Inquiry",
      stepStarted: "Application started",
      stepSubmitted: "Application submitted",
      stepReview: "Under review",
      stepAccepted: "Accepted",
      stepEnrolled: "Enrolled",
      stepScheduled: "Scheduled",
      stepActive: "Active",
    },
    admin: {
      dashboard: "Dashboard",
      inquiries: "Inquiry requests",
      applications: "Applications",
      admissions: "Admissions",
      enrollments: "Enrollments",
      reenrollment: "Re-enrollments",
      pendingPayments: "Payment simulator",
      payments: "Payments",
      sepa: "SEPA debits",
      scheduling: "Scheduling",
      grouping: "Grouping helper",
      myCourses: "My courses",
      section_admissions: "Admissions",
      section_studentLife: "Student Life",
      section_system: "System",
      calendar: "School calendar",
      families: "Families",
      students: "Students",
      sis: "SIS · Student Life",
      emails: "Emails",
      analytics: "Analytics",
      auditLogs: "Security · Audit",
      staff: "Staff · Accounts",
      settings: "Settings",
      totalInquiries: "Total inquiries",
      applicationsStarted: "Applications started",
      applicationsSubmitted: "Applications submitted",
      acceptedStudents: "Accepted students",
      enrolledStudents: "Enrolled students",
      conversionRate: "Conversion rate",
      revenuePipeline: "Revenue pipeline",
      pendingPayments: "Pending payments",
      byGrade: "By grade",
      byProgram: "By program",
      byCountry: "By country",
      convertToApplication: "Convert to application",
      sendEmail: "Send email",
      changeStatus: "Change status",
      noteAdded: "Note added",
      addNote: "Add note",
      tags: "Tags",
    },
    statuses: {
      new: "New",
      contacted: "Contacted",
      converted: "Converted",
      archived: "Archived",
      started: "Started",
      fee_pending: "Fee pending",
      submitted: "Submitted",
      under_review: "Under review",
      evaluation_sent: "Evaluation sent",
      evaluation_received: "Evaluation received",
      accepted: "Accepted",
      rejected: "Rejected",
      withdrawn: "Withdrawn",
      enrolled: "Enrolled",
      active: "Active",
      pending: "Pending",
      deposit_paid: "Deposit paid",
      paid_in_full: "Paid in full",
      plan_active: "Plan active",
      overdue: "Overdue",
      simulated: "Simulated",
    },
    payments: {
      annual: "One-time payment (annual)",
      biannual: "Two-installment payment",
      monthly: "Ten-installment payment (monthly)",
      custom: "Custom payment plan",
    },
    appSteps: {
      family: "Family",
      student: "Student",
      academic: "Academic background",
      language: "Language profile",
      program: "Program",
      documents: "Documents",
      consent: "Consent",
      docsTitle: "Report cards required",
      docsHelp: "Please upload report cards for the last 2 academic years: current year and previous year (PDF or image, 2.5 MB max per file).",
      docsCta: "Click to upload a report card",
    },
    legal: {
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      copyright: "© {year} OFA France — All rights reserved",
    },
    contract: {
      title: "Enrollment Agreement — Academic Year",
      preamble: "This agreement binds OFA France (the “School”) and the undersigned family (the “Family”) for the enrollment of the student designated on the platform.",
      art1Title: "Article 1 — Purpose",
      art1: "OFA France offers an online American academic pathway, parallel to the French school system, including academic English classes and, at the high-school level, American History classes for families pursuing the COGNIA-accredited US High School Diploma.",
      art2Title: "Article 2 — School's commitment",
      art2: "The School commits to delivering classes per the chosen track (Fluent Track or Bridge Track), at 1h30 per week for 32 weeks per year, in classes of 4 to 8 students, with experienced native-English teachers.",
      art3Title: "Article 3 — Family's commitment",
      art3: "The Family commits to ensuring the student's attendance, providing the required documents (last 2 years of report cards, ID) and paying tuition according to the selected payment plan.",
      art4Title: "Article 4 — Tuition",
      art4: "Annual tuition is €1,995 per course, for all grades from GS through Terminale (i.e. €3,990 for two courses). Three payment plans are available: one-time (annual), two-installment (semester) or ten-installment (monthly from October to July).",
      art5Title: "Article 5 — Cancellation and refunds",
      art5: "Any cancellation after the start of classes will be reviewed case by case. The first trimester is non-refundable. The Family may terminate at any time with a 30-day notice.",
      art6Title: "Article 6 — Personal data",
      art6: "OFA France processes personal data in compliance with GDPR. See our Privacy Policy for details.",
      art7Title: "Article 7 — Governing law",
      art7: "This agreement is governed by French law. Any dispute will fall under the jurisdiction of the courts of Paris.",
      signature: "By ticking the box below, I electronically sign this agreement and confirm enrollment.",
      readFull: "Read full contract",
      hideFull: "Hide contract",
    },
  },
};

export function getNested(obj, path) {
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}
